import React, { Fragment } from 'react';

const UserInfo = ({ user, userLoading }) => {
  return (
    <Fragment>
      {userLoading ? (
        <div className='card w-100 p-2 p-sm-3 p-lg-4 shadow-lg border-0 admin-list mb-2 h-max-content'>
          <div className='d-flex justify-content-center align-items-center h-100'>
            <div class='spinner-border txt-primary' role='status'>
              <span class='visually-hidden'>Loading...</span>
            </div>
          </div>
        </div>
      ) : (
        <div className='card w-100 p-2 p-sm-3 p-lg-4 shadow-lg border-0 admin-list mb-2 h-max-content '>
          <div className='mb-3'>
            <h5 className='fw-bold'>id</h5>
            <div className=''>{user.id}</div>
          </div>
          <div className='mb-3'>
            <h5 className='fw-bold'>Email</h5>
            <div className=''>{user.email}</div>
          </div>
          <div className='mb-3'>
            <h5 className='fw-bold'>Role</h5>
            <div className=''>{user.role}</div>
          </div>
          {user.client && (
            <div className='mb-3'>
              <h5 className='fw-bold'>Company</h5>
              <div className=''>{user.client}</div>
            </div>
          )}
        </div>
      )}
    </Fragment>
  );
};

export default UserInfo;
